/* eslint-disable max-len, no-console */
import * as yup from "yup";
import { Button, Form, Spinner } from "react-bootstrap";
import { useCallback, useEffect, useRef } from "react";
import { Formik } from "formik";
import { useMutation } from "react-query";
import { useNavigate } from "react-router";

import loginMFACode from "./getMFACodesMutation";

const schema = yup.object().shape({
	email: yup.string().email().
		required()
});

const ForgotPasswordForm = () => {
	const emailInput = useRef(null);
	const navigate = useNavigate();
	const {
		isLoading,
		mutateAsync: getMFACode
	} = loginMFACode(useMutation);
	const onSubmit = useCallback(async (values) => {
		try {
			await getMFACode({
				username: values.email
			});
			navigate(
				"/sign-in/confirm",
				{
					state: {
						email: values.email,
						redirect: "/profile/change-password",
						username: values.email
					}
				}
			);
		} catch (error) {
			console.error(error);
		}
	}, [getMFACode]);

	useEffect(() => emailInput.current?.focus(), []);

	return (
		<Formik
			initialValues={{
				email: ""
			}}
			onSubmit={onSubmit}
			validationSchema={schema}
		>
			{({
				errors,
				handleBlur,
				handleChange,
				handleSubmit,
				touched,
				values
			}) => (
				<Form noValidate onSubmit={handleSubmit}>
					<Form.Label>Email Address</Form.Label>
					<Form.Control
						isInvalid={Boolean(errors.email)}
						name="email"
						onBlur={handleBlur}
						onChange={handleChange}
						placeholder="alex@example.com"
						ref={emailInput}
						required
						type="email"
						value={values.email}
					/>
					<Form.Control.Feedback type="invalid">
						{touched.email && errors.email ? <p>{errors.email}</p> : null}
					</Form.Control.Feedback>

					<Button className="btn-gradient mt-4 w-100" type="submit">
						{isLoading ? <Spinner animation="border" size="sm" /> : "Reset Password"}
					</Button>
				</Form>
			)}
		</Formik>
	);
};

export default ForgotPasswordForm;
